import * as React from "react";
import TextField from "@material-ui/core/TextField";

class CustomTextField extends React.Component {
  handleChange = event => {
    this.props.onChange(event.target.name, event.target.value, event.target.type);
  };

  render() {
    const { value, label, name, readOnly, type } = this.props;
    return (
      <TextField
        onChange={this.handleChange}
        inputProps={{ readOnly }}
        value={value}
        label={label}
        key={name}
        name={name}
        type={type}
        InputLabelProps={{ shrink: true }}
        fullWidth
        margin="normal"
      />
    );
  }
}

export default CustomTextField;



// WEBPACK FOOTER //
// ./src/components/common/CustomTextField.js